import { Injectable, signal } from "@angular/core";
import { fromEvent, Observable } from "rxjs";
import { map, share } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class WindowResizeService {
  readonly width = signal(window.innerWidth);
  readonly windowResize$: Observable<number>;

  constructor() {
    this.windowResize$ = fromEvent(window, "resize").pipe(
      map(() => window.innerWidth),
      share()
    );

    this.windowResize$.subscribe(width => {
      this.width.set(width);
    });
  }
}
